'use strict';

function ARGB2HexDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function($scope, element, attr, ngModel) {
      function toHex(argb) {
        return '#'+ ('000000' + (argb & 0xFFFFFF).toString(16)).slice(-6);
      }

      function fromHex(hex) {
        if (7 !== hex.length) {
          return 0;
        }

        return parseInt("FF" + hex.substr(1), 16);
      }

      ngModel.$formatters.push(toHex);
      ngModel.$parsers.push(fromHex);
    }
  };
}

angular.module('dokiv')
  .directive('argb2hex', ARGB2HexDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ARGB2HexDirective.js
// module id = 232
// module chunks = 0